import React, { useEffect } from "react";
import styles from "./blogCategories.module.scss";
import { Outlet } from "react-router-dom";
import NavTabs from "../../components/mui/tabs/NavTab";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import { useDispatch } from "react-redux";
import { getAllBlogCategory } from "../../store/actions";

const tabs = [
  {
    id: "1",
    title: "Active",
    link: "/blogCategories",
  },
  {
    id: "2",
    title: "InActive",
    link: "/blogCategories/inActive",
  },
];

const BlogCategories = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllBlogCategory());
  }, [dispatch]);

  return (
    <div className={styles.container}>
      <StatusCard leftContent="BLOG CATEGORIES" />

      <div className={styles.top}>
        <NavTabs data={tabs} variant="fullWidth" />
      </div>

      <div className={styles.bottom}>
        <Outlet />
      </div>
    </div>
  );
};

export default BlogCategories;
